import classnames from 'classnames';
import React, { useState } from 'react';
import { Dropdown, Form, InputGroup } from 'react-bootstrap';

import './hui-input.scss';
import { HUIInputProps } from './types';

const HUIInput: React.FC<HUIInputProps> = ({ className, metadata, ...otherProps }) => {
  const { prefix, suffix, suggestions, onInputChange, hasError, ...inputProps } = otherProps;
  const [isFocused, setFocused] = useState(false);

  const handleSelectSuggestion = (event: React.MouseEvent<HTMLDivElement>) => {
    onInputChange(String(event.currentTarget.dataset.value));
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onInputChange(event.target.value);
    if (inputProps.onChange) {
      inputProps.onChange(event);
    }
  };

  const handleInputFocus = (event) => {
    setFocused(true);
    if (inputProps.onFocus) {
      inputProps.onFocus(event);
    }
  };

  const handleInputBlur = (event) => {
    setFocused(false);
    if (inputProps.onBlur) {
      inputProps.onBlur(event);
    }
  };

  const inputGroup = (
    <InputGroup className={classnames('hui-input', className, { error: hasError })} {...metadata}>
      {prefix && <InputGroup.Text>{prefix}</InputGroup.Text>}
      <Form.Control {...inputProps} onChange={handleInputChange} onFocus={handleInputFocus} onBlur={handleInputBlur} />
      {suffix && <InputGroup.Text>{suffix}</InputGroup.Text>}
    </InputGroup>
  );

  if (suggestions && suggestions.length > 0) {
    return (
      <Dropdown show={isFocused}>
        {inputGroup}
        <Dropdown.Menu className="hui-input-suggestions">
          {suggestions.map((option) => (
            <Dropdown.Item key={option.value} data-value={option.value} onMouseDown={handleSelectSuggestion}>
              {option.text}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    );
  }

  return inputGroup;
};

HUIInput.displayName = 'HUIInput';

export default HUIInput;
